import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {Nav} from '../components/Nav';
import Footer from '../components/Footer';

export const PublicPages = () => {
  const isAuthenticated = sessionStorage.getItem("isOnline");
  return  (!isAuthenticated || isAuthenticated === undefined) ? <><Nav /> <Outlet/><Footer/></> : <Navigate to="admin/dashboard"/>
    
}